var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseModal", {
    attrs: { id: _vm.id, modalClass: "modal-md", showCloseButton: false },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.titlefreetrialended")) +
                  "\n    "
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "container-body" }, [
              _c("p", {
                staticClass: "mb-0",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("message.bodyfreetrialended1"))
                }
              })
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("div", { staticClass: "container-footer" }, [
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-web",
                    attrs: { type: "button" },
                    on: { click: _vm.onClickAck }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("button.acknowledge")) +
                        "\n        "
                    )
                  ]
                )
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b58350a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b58350a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModalAckFreeTrialEnded.vue
// module id = null
// module chunks = 